import React, { useEffect, useState } from 'react';
import { Grid, TextField, Button, Typography, Box, CircularProgress } from '@mui/material';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import api from "../utils/Url"; // Make sure this is your API utility file
import logo from '../assets/images/qq.png';
import "./index.css";
//import LoginImg from "./loginImg.jpg"; #9db9cf
import LoginImg2 from "./loginImg2.jpg";
//import LoginBgImg from "./login-bgImg.png"

const Login_Page = () => {
   const [loading, setLoading] = useState(false);
   const [isSignUpMode, setIsSignUpMode] = useState(false);
   const navigate = useNavigate();



   useEffect(() => {
   
      dynamicData();
     
    }, []);
  
    const dynamicData =()=>{
  
      const collectData = {
        id:1
      }
     
      api.post(`Institute_Master/GetInstitute_Master`,collectData)
      .then((res:any) => {
        
         console.log("🚀 ~ dynamicData ~ res:", res.data.data)
        if(res.data.data.length >0){
          localStorage.setItem("sidelogo", res.data.data[0]["instLogo"]);
          localStorage.setItem("applogo", res.data.data[0]["reportheaderimg"]);
          localStorage.setItem("name", res.data.data[0]["insname"]);
          localStorage.setItem("mclr", res.data.data[0]["mBackColor"]);
          localStorage.setItem("oclr", res.data.data[0]["mOverColor"]);
        
        }
      })
    }
  

   // Handle switching between Sign In and Sign Up modes
   const handleSignUpClick = () => setIsSignUpMode(true);
   const handleSignInClick = () => setIsSignUpMode(false);

   // Validation Schema for Formik (Username and Password are required)
   const validationSchema = Yup.object({
      useR_ID: Yup.string().required("Username Required"),
      password: Yup.string().required("Password Required"),
   });

   // Formik hook for form management
   const formik = useFormik({
      initialValues: {
         useR_ID: "",
         password: "",
      },
      validationSchema,
      onSubmit: async (values) => {
         try {
            setLoading(true);
            const response = await api.post('Auth/USERLOGIN', values);

            // Check if login is successful
            if (response.data.isSuccess) {
               localStorage.setItem("userdata", JSON.stringify(response.data.data));
               localStorage.setItem("useR_ID", JSON.stringify(response.data.data[0].userdetail[0].useR_ID));
               sessionStorage.setItem("token", JSON.stringify(response.data.data[0].token));
               //toast.success(response.data.mesg);
               navigate("/home");
            } else {
               toast.error(response.data.mesg);
            }
         } catch (error) {
            toast.error("Login Failed");
         } finally {
            setLoading(false);
         }
      },
   });

   return (
      <Grid container sx={{ height: '100vh' }}>
         <Grid item xs={12} md={6} sx={{ backgroundImage: `url(${LoginImg2})`, backgroundSize: 'cover' }}>
         </Grid>
         <Grid item xs={12} md={6} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' , backgroundColor:"#ffcc8a",}}>
            <Box sx={{ width: '100%', maxWidth: 400, padding: 3,backgroundColor:"#e6f1ff",borderRadius:"3rem" }}>
               {/* Logo Image */}
               <Box sx={{ textAlign: 'center', marginBottom: 2 }}>
                  <img
                     src={logo}
                     alt="Logo"
                     style={{ width: '170px', height: 'auto' }}
                  />

                  <div>
                     <h3 className="loginh3">Pole and Street Light (Asset) Management System</h3>
                  </div>
                  <br />
                  <i className="title">"Illuminating Pathways, Ensuring Safety!"</i>

               </Box>

               <Typography variant="h5" align="center" gutterBottom>
                  {isSignUpMode ? 'Sign Up' : 'Pole Track'}
               </Typography>

               {/* Login / SignUp Form */}
               <form onSubmit={formik.handleSubmit}>
                  <TextField
                     fullWidth
                     id="useR_ID"
                     name="useR_ID"
                     label="Username"
                     value={formik.values.useR_ID}
                     onChange={formik.handleChange}
                     onBlur={formik.handleBlur}
                     error={formik.touched.useR_ID && Boolean(formik.errors.useR_ID)}
                     helperText={formik.touched.useR_ID && formik.errors.useR_ID}
                     sx={{ marginBottom: 2 }}
                     size="small"
                  />
                  <TextField
                     fullWidth
                     id="password"
                     name="password"
                     label="Password"
                     type="password"
                     value={formik.values.password}
                     onChange={formik.handleChange}
                     onBlur={formik.handleBlur}
                     error={formik.touched.password && Boolean(formik.errors.password)}
                     helperText={formik.touched.password && formik.errors.password}
                     sx={{ marginBottom: 2 }}
                     size="small"
                  />

                  <Button
                     fullWidth
                     variant="contained"
                     color="primary"
                     type="submit"
                     disabled={loading}
                     sx={{ marginBottom: 2 }}
                  >
                     {loading ? <CircularProgress size={24} /> : 'Login'}
                  </Button>

                  {/* <Grid container justifyContent="space-between">
                     <Grid item>
                        <Button onClick={handleSignInClick} disabled={loading}>
                           Sign In
                        </Button>
                     </Grid>
                     <Grid item>
                        <Button onClick={handleSignUpClick} disabled={loading}>
                           Sign Up
                        </Button>
                     </Grid>
                  </Grid> */}
               </form>
            </Box>
         </Grid>

      </Grid>

   );

};

export default Login_Page;